import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import axios from "axios";
import "jspdf-autotable";

export default function toPDF(m2quantity, email) {
  // window.scrollTo(0, 0);
  // html2canvas(document.querySelector("#toPrint")).then(canvas => {
  //   //document.body.appendChild(canvas); // if you want see your screenshot in body.
  //   const imgData = canvas.toDataURL("image/png");
  //   const pdf = new jsPDF({ orientation: "landscape" });

  //   var width =
  //     pdf.internal.pageSize.getWidth() - pdf.internal.pageSize.getWidth() * 0.3;
  //   var height =
  //     pdf.internal.pageSize.getHeight() -
  //     pdf.internal.pageSize.getHeight() * 0.3;

  //   pdf.addImage(imgData, "PNG", 50, 35, width, height);
  //   pdf.text("m2 Solicitados: " + String(m2quantity), 10, 10);

  //   const pdffilepath = pdf.output("datauristring");

  //   const emailJSON = {
  //     toemail: email,
  //     pdffile: pdffilepath
  //   };

  //   pdf.save("knauf.pdf");
  //   let res = axios.post("http://190.105.227.203/knauf/sendPDF", emailJSON);

  //   console.log("Response: "+res);
  // });
  const input = document.getElementById("toPrint");
  const input2 = document.getElementById("toPrint2");
  const pdf = new jsPDF({ orientation: "landscape" });
  console.log(input);

  pdf.autoTable({ html: input });
  pdf.autoTable({ html: input2 });
  //pdf.save("knauf.pdf");
  const pdffilepath = pdf.output("datauristring");

  const emailJSON = {
    toemail: email,
    pdffile: pdffilepath
  };

  
  let res = axios.post("http://190.105.227.203/knauf/sendPDF", emailJSON);

  console.log("Response: " + res);
}
